import AuthApiService from '@services/auth.api.service';
import JWTService from '@services/jwt.service';

import { removeLastSlashFromUrl } from '@helpers';

import { MutationTypes, ActionTypes } from '@store/modules/auth.types';
import { namespace as AppNamespace } from '@store/modules/app.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

export default {
  namespaced: true,
  state: {
    token: JWTService.getToken(),
    isAuthenticated: false,
    returnUrl: null,
  },
  mutations: {
    [MutationTypes.SET_AUTH](state, payload) {
      state.isAuthenticated = payload;
    },
    [MutationTypes.SET_TOKEN](state, payload) {
      state.token = payload;
      if (payload) {
        JWTService.setToken(payload);
      } else {
        JWTService.removeToken();
      }
    },
    [MutationTypes.SET_RETURN_URL](state, payload) {
      state.returnUrl = payload;
    },
  },
  actions: {
    async [ActionTypes.GENERATE_TOKEN_FROM_URL](
      { state: { token: TOKEN }, commit, dispatch },
      { query },
    ) {
      const q = JSON.parse(JSON.stringify(query));
      const { umToken: UM_TOKEN } = q;

      if (!UM_TOKEN && !TOKEN) {
        dispatch(ActionTypes.LOGOUT, { routeName: 'login' });
        return Promise.reject();
      }

      JWTService.setToken(UM_TOKEN || TOKEN);

      await AuthApiService.checkUserAuth();

      commit(MutationTypes.SET_AUTH, true);

      if (UM_TOKEN) {
        commit(MutationTypes.SET_TOKEN, UM_TOKEN);

        delete q.umToken;
        delete q.expires;
      }

      return Promise.resolve(q);
    },
    [ActionTypes.LOGIN]({
      state: { returnUrl },
      rootState: {
        [AppNamespace]: { userManagerUrl, clientId },
        [LocationsNamespace]: { suffix },
      },
    }) {
      window.location = `${
        removeLastSlashFromUrl(userManagerUrl)
      }/OuterAccount/Login?service=${
        clientId
      }&returnUrl=${
        encodeURIComponent(returnUrl || `${
          window.location.origin
        }/?suffix=${
          suffix || ''
        }`)
      }`;
    },
    [ActionTypes.LOGOUT]({ commit }, { routeName } = {}) {
      commit(MutationTypes.SET_TOKEN, null);
      commit(MutationTypes.SET_AUTH, false);

      if (routeName !== 'login' && routeName !== 'forbidden') {
        commit(MutationTypes.SET_RETURN_URL, window.location.href);
      }
    },
  },
};
